import { Component } from 'react';

export default class Logout extends Component {

    componentWillMount() {
        localStorage.removeItem('usuario');
        localStorage.removeItem('usuario_id');
        localStorage.removeItem('empresa_id');
        localStorage.removeItem('token');
        this.props.history.push('/');
    }

    render() {
        return null;
    }
}